import styled from 'styled-components';

import AutoCredit from '~/common/components/AutoCredit';
import {AutoCreditVariant} from '~/shared/components/AutoCreditView';
import {useIsMinLargeMobile} from '~/shared/hooks/deviceInfo';

import {getCreditViewSettings} from '../utils';
import AddToCredit from '../../AddToCredit/AddToCredit';

const AutoCreditWrapper = styled.div`
  margin-top: 16px;
`;

const CreditSection = ({
  availableAmount,
  moneycardId,
  encryptedMoneycardId,
  setOrderListData,
  onAutoCreditSubscribeSuccess,
  tenbisCreditConversion,
}) => {
  const isMinLargeMobile = useIsMinLargeMobile();
  const {showAutoCredit, showManualCreditLoad, isAutoCreditActive} = getCreditViewSettings(tenbisCreditConversion);

  return (
    <>
      {showManualCreditLoad && (
        <AddToCredit
          setOrderListData={setOrderListData}
          availableAmount={availableAmount}
          moneycardId={moneycardId}
          encryptedMoneycardId={encryptedMoneycardId}
          showAutoCredit={showAutoCredit}
          isAutoCreditActive={isAutoCreditActive}
          onAutoCreditSubscribeSuccess={onAutoCreditSubscribeSuccess}
        />
      )}
      {showAutoCredit && (
        <AutoCreditWrapper >
          <AutoCredit
            variant={isMinLargeMobile ? AutoCreditVariant.DEFAULT : AutoCreditVariant.COMPACT}
            moneycardId={moneycardId}
            encryptedMoneycardId={encryptedMoneycardId}
            isActive={isAutoCreditActive}
            onSuccess={onAutoCreditSubscribeSuccess}
          />
        </AutoCreditWrapper>
      )}
    </>
  );
};

export default CreditSection;
